/**
 * The Terms of Use, Privacy Policy and support pages, and the version of the
 * terms this client shows. Creating an account sends that version, so it
 * must be one the server publishes (`apps/backend/core/terms.py`).
 */
export const TERMS_VERSION = '2026-10-25';

export const TERMS_URL = 'https://mainquestmarket.com/terms';
export const PRIVACY_URL = 'https://mainquestmarket.com/privacy';
export const SUPPORT_URL = 'https://mainquestmarket.com/support';
